// src/components/Header.jsx
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";
import { AUTH_DISPLAY_EVENT, getAuthDisplay } from "../authDisplay";

const PUBLIC = process.env.PUBLIC_URL || "";

function useHashNav() {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    return (id) => (e) => {
        e.preventDefault();
        if (pathname === "/") {
            const el = document.getElementById(id);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
            navigate(`/#${id}`);
        }
    };
}

export default function Header() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [authDisplay, setAuthDisplayState] = useState(() => getAuthDisplay());
    const { pathname } = useLocation();
    const goTo = useHashNav();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        const syncAuthDisplay = () => setAuthDisplayState(getAuthDisplay());
        window.addEventListener(AUTH_DISPLAY_EVENT, syncAuthDisplay);
        window.addEventListener("storage", syncAuthDisplay);
        return () => {
            window.removeEventListener(AUTH_DISPLAY_EVENT, syncAuthDisplay);
            window.removeEventListener("storage", syncAuthDisplay);
        };
    }, []);

    const navLoginLabel = authDisplay.label || "Login";
    const isLoggedInDisplay = Boolean(authDisplay.label);

    return (
        <header className={`site-header ${scrolled ? "scrolled" : ""}`}>
            <div className="logo">
                <Link to="/" className="brand" onClick={() => setOpen(false)}>
                    <img
                        src={`${PUBLIC}/LogoGIF/Soalroll_Logo.gif`}
                        alt="Logo"
                        onError={(e) => (e.currentTarget.style.display = "none")}
                    />
                    <span>
                        Southern Alberta Regional Council
                        <br />
                        Triskelions Grand Fraternity and Sorority
                    </span>
                </Link>
            </div>

            <button
                className={`menu-toggle ${open ? "open" : ""}`}
                aria-expanded={open}
                aria-label={open ? "Close navigation menu" : "Open navigation menu"}
                onClick={() => setOpen((o) => !o)}
            >
                ☰
            </button>

            <nav className={`site-nav ${open ? "open" : ""}`}>
                <ul>
                    {/* HOME -> /#home, smooth scroll if already on "/" */}
                    <li>
                        <a
                            href="/#home"
                            className={`nav-link ${pathname === "/" ? "active" : ""}`}
                            onClick={(e) => {
                                setOpen(false);
                                goTo("home")(e);
                            }}
                        >
                            Home
                        </a>
                    </li>

                    {/* About Us -> History section */}
                    <li>
                        <a
                            href="/#about"
                            className="nav-link"
                            onClick={(e) => {
                                setOpen(false);
                                goTo("about")(e);
                            }}
                        >
                            About Us
                        </a>
                    </li>

                    <li>
                        <a
                            href="/#gallery"
                            className="nav-link"
                            onClick={(e) => {
                                setOpen(false);
                                goTo("gallery")(e);
                            }}
                        >
                            Gallery
                        </a>
                    </li>        

                    <li>
                        <a
                            href="/#cncouncils"
                            className="nav-link"
                            onClick={(e) => {
                                setOpen(false);
                                goTo("cncouncils")(e);
                            }}
                        >
                            CNC Councils
                        </a>
                    </li>

                   { /* <li>
                        <a
                            href="/#business"
                            className="nav-link"
                            onClick={(e) => {
                                setOpen(false);
                                goTo("business")(e);
                            }}
                        >
                            Businesses
                        </a>
                    </li> */}

                    <li>
                        <a
                            href="/#contact"
                            className="nav-link"
                            onClick={(e) => {
                                setOpen(false);
                                goTo("contact")(e);
                            }}
                        >
                            Contact Us
                        </a>
                    </li>
                    <li>
                        <Link
                            to="/member"
                            className={`nav-link auth-nav-link ${isLoggedInDisplay ? "logged-in" : ""}`}
                            onClick={() => setOpen(false)}
                            aria-label={isLoggedInDisplay ? `Member account ${navLoginLabel}` : "Login"}
                        >
                            {isLoggedInDisplay ? (
                                <strong className="nav-auth-badge">{navLoginLabel}</strong>
                            ) : (
                                <strong>Login</strong>
                            )}
                        </Link>
                    </li>

                </ul>
            </nav>
        </header>
    );
}
